import { css } from 'linaria';
import { strictBreakpoints } from '../../../media';

export const ctaBlockStyles = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;
	padding: 24px 93px;
	color: var(--text-primary-invert);
	background-color: var(--text-primary);
	${strictBreakpoints.onlyDesktop} {
		padding: 24px 42px;
	}
	${strictBreakpoints.onlyTablet} {
		flex-direction: column;
		align-items: flex-start;
		padding: 24px 54px;
	}
	${strictBreakpoints.onlyMobile} {
		flex-direction: column;
		align-items: flex-start;
		padding: 24px 16px;
	}

	.cta-text {
		display: flex;
		align-items: center;
		gap: 24px;
		${strictBreakpoints.onlyMobile} {
			flex-direction: column;
			align-items: flex-start;
			gap: 16px;
		}
	}

	.cta-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 12px 24px;
		background: #fdc300;
		border-radius: 4px;

		&:hover {
			color: #333 !important;
		}
		${strictBreakpoints.onlyTablet} {
			align-self: flex-end;
		}
	}
`;
